import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CommonService } from '@shared/services/Common/common.service';

/**
 * Interceptor de permisos (Fase 4.3).
 *
 * Detecta respuestas 403 (Forbidden) — que el backend emite cuando un miembro del
 * staff intenta una acción sin el permiso necesario — y muestra una notificación
 * clara al usuario. Así el feedback es consistente en toda la app sin depender de
 * que cada componente gestione el error por su cuenta.
 *
 * El error se re-lanza para que los componentes puedan seguir su flujo normal
 * (p. ej. no cerrar un diálogo). Los componentes que muestran su propio alert
 * deben comprobar `isPermissionDenied(error)` para evitar notificaciones duplicadas.
 */
export function permissionErrorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const commonService = inject(CommonService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const message = extractErrorMessage(error) || 'No tienes permisos para realizar esta acción';
        commonService.showAlert('warning', message, 4000);
      }
      return throwError(() => error);
    }),
  );
}

/** Extrae el mensaje de error del cuerpo de la respuesta (string o array de validación). */
function extractErrorMessage(error: HttpErrorResponse): string {
  const body = error.error;
  if (body && typeof body.message === 'string') return body.message;
  if (body && Array.isArray(body.message) && body.message.length) return String(body.message[0]);
  return '';
}
